import { http, defaultConfig, getUniversityUrl } from './http';

export const list = () => {
  const baseURL = getUniversityUrl();
  if (!baseURL) return;
  return http.get<{ payload: HttpResponsePayload<AnnouncementEntity[]> }>('/rest/announcements', defaultConfig(baseURL, { auth: false, headers: {} }));
};
